<template>
  <div class="main-content">
    <el-row :class="isfixed ? 'fixed-page':''">
      <el-col :span="8" style="line-height:40px;">
        <el-dropdown @command="onInterviewTypeChange">
          <span class="el-dropdown-link">
            {{InterviewTypeText}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="all">全部面试</el-dropdown-item>
            <el-dropdown-item command="today">今日面试</el-dropdown-item>
            <el-dropdown-item command="noInterview">未面试</el-dropdown-item>
            <el-dropdown-item command="interviewed">已面试</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <el-col :span="16" style="text-align:right;">
        <el-pagination background @current-change="onCurrentChange" :current-page="currentPage" :page-sizes="[10]"
          :page-size="pageSize" layout="slot, prev, pager, next" :total="total">
          <span class="el-pagination__total">共 {{total}} 条记录</span>
        </el-pagination>
      </el-col>
    </el-row>
    <div class="job-list-wrap">
      <ul>
        <li class="job-item" v-for="(item) in interviewList" :key="item.interview_id">
            <div style="padding: 30px; cursor: pointer;" @click="toInterviewDetail(item.LoInterviewNos)">
                <el-row>
                  <el-col :span="2">
                    <user-avatar :src="item.img" class="useravatar-cicle-m"></user-avatar>
                  </el-col>
                  <el-col :span="6">
                    <p class="job-info-title"> {{item.name}}</p>
                    <p class="info-labels">
                      <span v-if="item.degree">{{item.degree}}<el-divider direction="vertical"></el-divider></span>
                      {{item.work_exp}} 年经验
                    </p>
                  </el-col>
                  <el-col :span="10" style="font-size: 14px; line-height: 22px; color: #323233">
                    <div>面试职位：{{item.position}}</div>
                    <div>面试时间：{{$Shared.formatDateTime2(item.interview_time)}}</div>
                    <div>面试地点：{{item.interview_place}}</div>
                  </el-col>
                  <el-col :span="3" style="font-size: 14px;line-height: 65px; color: #323233">
                    <div>{{item.interview_round}}</div>
                  </el-col>
                  <el-col :span="3" class="text-right" style="font-size: 14px;line-height: 65px;">
                    <el-button type="text" v-if="item.interview_status_id == 41" @click.stop="onSetResult(item)">设置结果</el-button>
                    <div v-else style="color: #323233">{{item.interview_status}}</div>
                  </el-col>
                </el-row>
            </div>
        </li>
      </ul>
      <div class="nomore" v-if="!loading && interviewList.length === 0">当前没有更多面试</div>
    </div>
    <interview-result-dialog :visible="resultVisible" :interviewId="interviewId" @close="onResultClose" @success="onResultSuccess" @interview="toCreateInterview"></interview-result-dialog>
    <interview-recreate-dialog :visible="createVisible" :interviewId="interviewId" @close="onCreateClose" @success="onCreateSuccess"></interview-recreate-dialog>
  </div>
</template>

<script>
  import {
    getList
  } from '~/api/interview';
  import userAvatar from '~/components/UserAvatar';
  import interviewResultDialog from '~/components/InterviewResultDialog';
  import interviewRecreateDialog from '~/components/InterviewRecreateDialog';
  export default {
    components: {
      userAvatar,
      interviewResultDialog,
      interviewRecreateDialog
    },
    data() {
      return {
        InterviewTypeText: '全部面试',
        isTodayInterview: false,
        interviewStatus: 0,
        currentPage: 1,
        pageSize: 6,
        total: 0,
        interviewList: [],
        loading: false,
        resultVisible: false,
        interviewId: 0,
        createVisible: false,
        isfixed: false,
      };
    },
    created() {
      this.$emit('changeMenu', 'Interview');
      this.getInterviewList();
    },
    mounted() {
      window.addEventListener('scroll', this.handlePageFix, true);
    },
    methods: {
      handlePageFix() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var elItem = document.querySelector('.main-content');
        var offsetTop = elItem.offsetTop;
        scrollTop > offsetTop ? this.isfixed = true : this.isfixed = false;
      },
      getInterviewList() {
        this.loading = true;
        const loadingMask = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)',
          target: document.querySelector('.job-list-wrap')
        });
        var params = {
          is_today_interview: this.isTodayInterview,
          interview_status: this.interviewStatus,
          page_index: this.currentPage,
          interview_type: 0,
          page_size: this.pageSize,
        };
        getList(params).then(r => {
          this.loading = false;
          loadingMask.close();
          if (r.errcode === 0) {
            let datas = r.data.list;
            this.interviewList = datas;
            this.total = r.data.total_item_count;
          }
        });
      },
      onInterviewTypeChange(val) {
        switch (val) {
        case 'all':
          this.isTodayInterview = false;
          this.interviewStatus = 0;
          this.InterviewTypeText = '全部';
          break;
        case 'today':
          this.isTodayInterview = true;
          this.interviewStatus = 1;
          this.InterviewTypeText = '今日面试';
          break;
        case 'noInterview':
          this.isTodayInterview = false;
          this.interviewStatus = 2;
          this.InterviewTypeText = '未面试';
          break;
        case 'interviewed':
          this.isTodayInterview = false;
          this.interviewStatus = 3;
          this.InterviewTypeText = '已面试';
          break;
        }
        this.currentPage = 1;
        this.interviewList = [];
        this.getInterviewList();
      },
      onCurrentChange(index) {
        this.currentPage = index;
        this.getInterviewList();
      },
      toInterviewDetail(interviewNo){
        this.$router.push({name:'InterviewDetail', query: {id: interviewNo}});
      },
      onSetResult(interview){
        // console.log(interview);
        this.interviewId = interview.interview_id;
        this.resultVisible = true;
      },
      onResultClose(){
        this.resultVisible = false;
      },
      onResultSuccess(){
        this.getInterviewList();
        this.resultVisible = false;
      },
      onCreateClose(){
        this.createVisible = false;
      },
      onCreateSuccess(interviewId){
        this.getInterviewList();
        this.createVisible = false;
      },
      toCreateInterview(interviewId){
        this.interviewId = interviewId;
        this.resultVisible = false;
        this.createVisible = true;
      },
    }
  };
</script>

<style scoped>
  .main-content {
    text-align: left;
  }
  .nomore{
    padding: 30px;
  }
</style>